import React from 'react';
import { CheckIcon, PlusIcon } from 'lucide-react';
import { BonusCover } from '../BonusCover';
import { Accent, SectionHeading } from './SectionHeading';
import { bonusIncludes, bonuses, coreIncludes } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';

/** Section 11 — everything included, with the biggest mockup on the page. */
export function LibrarySection() {
  return <section aria-labelledby="library-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-141" data-mp="1ahfal0zsevdg">
      <div className="mx-auto max-w-6xl" data-id="element-142" data-mp="1f8x8fg6ikfu7">
        <SectionHeading id="library-heading" eyebrow="Everything You Get" title={<>
              Here's Everything <Accent data-id="element-144" data-mp="16ftw5b7lu915">Waiting Inside.</Accent>
            </>} data-id="element-143" data-mp="1f9yltrb05ef3" />

        <img src={MOCKUP_URL} alt="The six core volumes of Makeup Instructor Ready with real pages on tablet, laptop and phone" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block w-full" style={{
        filter: 'drop-shadow(0 30px 36px rgba(59, 27, 87, 0.18))'
      }} data-id="element-145" data-mp="rj30nd11xhgt" />

        <div className="mt-4 flex flex-col items-center" data-id="element-146" data-mp="3dcndxswmfuog">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-brand-plum text-white" data-id="element-147" data-mp="3r8r9pqn58b31">
            <PlusIcon className="h-5 w-5" strokeWidth={2.25} aria-hidden="true" data-id="element-148" data-mp="3n8yyf66d7qtz" />
            <span className="sr-only" data-id="element-149" data-mp="2zjo1jzs4ygl4">Plus</span>
          </span>
          <ul className="mt-5 flex w-full max-w-2xl justify-center gap-2 sm:gap-4" role="list" aria-label="5 extra bonuses" data-id="element-150" data-mp="2uk1lzjou4o95">
            {bonuses.map(bonus => <li key={bonus.number} className="w-[19%] max-w-[110px]" data-id="element-151" data-mp="38dattfx4x1pk">
                <BonusCover label={bonus.number.replace('#', '')} title={bonus.coverTitle} color={bonus.color} className="w-full" data-id="element-152" data-mp="33johjouvuzua" />
              </li>)}
          </ul>
          <p className="mt-4 font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-charcoal/55" data-id="element-153" data-mp="2bu3hfdk8xda9">
            5 Extra Bonuses
          </p>
        </div>

        <div className="mx-auto mt-14 grid max-w-4xl gap-8 sm:grid-cols-2 sm:gap-12" data-id="element-154" data-mp="jrhat80m32sx">
          <div data-id="element-155" data-mp="jpeds411k9ep">
            <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-plum" data-id="element-156" data-mp="oir027i9044a">
              6 core volumes
            </p>
            <ul className="mt-4 space-y-3" role="list" data-id="element-157" data-mp="tgsgsls7brcl">
              {coreIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] font-semibold leading-snug text-brand-charcoal" data-id="element-158" data-mp="3s10pumyp3aci">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-159" data-mp="5rzg6c0mwvbn" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-160" data-mp="1h7emi6eqgzjf">
            <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-charcoal/50" data-id="element-161" data-mp="1h7xtwt6rc5j7">Plus</p>
            <ul className="mt-4 space-y-3" role="list" data-id="element-162" data-mp="1m4wm366v22er">
              {bonusIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] leading-snug text-brand-charcoal/80" data-id="element-163" data-mp="36nqpim5hasxn">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-164" data-mp="31pyv9lhd2uqa" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-14 text-center" data-id="element-165" data-mp="2n0axgu8e2e7b">
          <p className="font-display text-[2.2rem] font-bold leading-[1.05] text-brand-charcoal sm:text-[3rem]" data-id="element-166" data-mp="2n12hr8wjcpia">
            11 Professional <Accent data-id="element-167" data-mp="2j0sbrw8qtz3f">Digital Resources</Accent>
          </p>
          <p className="mt-3 text-[16px] text-brand-charcoal/70" data-id="element-168" data-mp="2e0nu42w3mybm">One complete makeup teaching ecosystem.</p>
        </div>
      </div>
    </section>;
}